










































import { defineComponent, reactive, ref } from '@vue/composition-api';
import { OlbInput, OlbFlyoutSelect } from '../form';
import { ValidationObserver } from 'vee-validate';
import OlbButton from '../button';
import { SelectOption } from './types';

export default defineComponent({
	components: {
		OlbInput,
		OlbFlyoutSelect,
		OlbButton,
		ValidationObserver,
	},
	props: {
		title: {
			type: String,
		},
		immoTypeLabel: {
			type: String,
		},
		immoTypes: {
			type: Array as () => SelectOption[],
			required: true,
		},
		action: {
			type: String,
		},
	},
	setup() {
		const observer = ref();
		const formData = reactive({
			type: '',
			zip: '',
			city: '',
		});
		async function onSubmit(e: Event) {
			e.preventDefault();
			const isValid = await observer.value.validate();
			if (!isValid) {
				return;
			}
			(e.target as HTMLFormElement).submit();
		}
		return { formData, onSubmit, observer };
	},
});
